/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates some simple date formats to be used.
 */
export var FirstWeek = /*@__PURE__*/ (function (FirstWeek) {
    /**
     * First Day of Year is Start of First Week
     */
    FirstWeek[FirstWeek["FirstDay"] = 0] = "FirstDay";
    /**
     * First Full Week in year is First Week
     */
    FirstWeek[FirstWeek["FirstFullWeek"] = 1] = "FirstFullWeek";
    /**
     * First Four Day Week in year is First Week
     */
    FirstWeek[FirstWeek["FirstFourDayWeek"] = 2] = "FirstFourDayWeek";
    return FirstWeek;
})({});
/**
 * @hidden
 */
export var FirstWeek_$type = /*@__PURE__*/ markEnum('FirstWeek', 'FirstDay,0|FirstFullWeek,1|FirstFourDayWeek,2');
//# sourceMappingURL=FirstWeek.js.map
